export const version = "wordlists/5.6.1";
